<template>
  <div></div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { auth0Logout } from "@/composables/useAuth0.js";
import { useStore } from "vuex";

const isAuth0 = process.env.VUE_APP_AUTH0_ENABLED === "true";

export default {
  name: "Logout",
  setup() {
    const router = useRouter();
    const axios = axiosInstance().primoLab;
    const store = useStore();

    const logout = async () => {
      try {
        await axios.post("/auth/logout");
      } catch (error) {
        console.error("Logout API error:", error?.response?.data);
      }

      // Remove auth/session data but preserve stuck_work_last_shown_* (polling cooldown)
      localStorage.removeItem("authToken");
      window.localStorage.removeItem("vuex");
      await store.dispatch("setUser", null);

      if (isAuth0) {
        // Auth0: redirec logout
        await auth0Logout();
      } else {
        // Legacy: redirect to login page.
        await router.push("/login");
      }
    };

    onMounted(logout);
  },
};
</script>
